var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m449.45 0c34.525 0 62.554 28.03 62.554 62.554v386.89c0 34.524-28.03 62.554-62.554 62.554h-106.47v-192.92h66.6l12.672-82.621h-79.272v-53.617c0-22.603 11.073-44.636 46.58-44.636h36.042v-70.34s-32.71-5.582-63.982-5.582c-65.288 0-107.96 39.569-107.96 111.2v62.971h-72.573v82.621h72.573v192.92h-191.1c-34.524 0-62.554-28.03-62.554-62.554v-386.89c0-34.524 28.029-62.554 62.554-62.554h386.89z",
    fill: "#1777f2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.27cdc27acd49f385f3b6ea70c5511fde.svg";
export { ForwardRef as ReactComponent };